import React from 'react';
import {useTranslation} from 'react-i18next';
import s from './StatusRestrictionMessage.module.css';

interface StatusRestrictionMessageProps {
	message: string;
}

const StatusRestrictionMessage: React.FC<StatusRestrictionMessageProps> = ({
	message,
}) => {
	const {t} = useTranslation();
	return <div className={s.messageBlock}>{t(message)}</div>;
};

export default StatusRestrictionMessage;

